const config = {
    emailjs: {
        serviceId: 'service_ld7ehlj',
        templateId: 'template_fjjbsxc',
        userId: 'm9e7ZEE3vHls0cR1g',
    },
};

export default config;